import notifications from '@imt/vue-admin-menus/src/store/notifications';
import toolbox from '@imt/vue-toolbox/src/store';
import utils, {axiosWithAuth} from '@imt/vue-toolbox/src/utils';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export const axios = axiosWithAuth();

export const actions = {
    async fetchConfigurations({ commit }, url = '/configurations/') {
        const response = await axios.get(url);

        commit('SET_CONFIGURATIONS', utils.dataFormatter.deserialize(response.data));
    },
    async saveConfiguration(_, {payload, url = '/configurations/'}) {
        let method = 'post';

        if (payload.id) {
            method = 'patch';
            url += `${payload.id}/`;
        }

        return await axios[method](url, utils.dataFormatter.serialize({stuff: payload}));
    },
};

export const mutations = {
    SET_CONFIGURATIONS(state, configurations) {
        state.configurations = configurations;
    },
};

export const state = {
    configurations: [],
};

export const configuration = {
    namespaced: true,
    actions,
    mutations,
    state,
};

export default new Vuex.Store({
    modules: {
        configuration,
        notifications,
        toolbox,
    },
});
